import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import AurPagination from '../../../common/aur-pagination/AurPagination';

const Pagination: React.FC = () => {
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const pageChangeHandler = () => {
    alert('Page changed');
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Pagination</h1>
        <div>
          The Pagination component enables the user to select a specific page
          from a range of pages.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurPagination
            totalItems={100}
            itemsPerPage={itemsPerPage}
            currentPage={1}
            itemType="items"
            onPageChange={pageChangeHandler}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default Pagination;
